import {i18n as t} from '@/i18n/i18n-service-provider';

export const getErrorFromResponse = (response: any, defaultErrorMessage: string): string => {
  const errorCode: string|null = getErrorCodeFromResponse(response);
  let errorMessage: string|null|any = null;

  if (errorCode) {
    errorMessage = getErrorMessageFromTranslationByErrorCode(errorCode);
  }

  if (null === errorMessage) {
    errorMessage = getErrorMessageFromResponse(response, defaultErrorMessage);
  }

  return errorMessage;
};

export const getErrorCodeFromResponse = (response: any): string|null => {
  const errors = response.errors || response.error;

  if (!errors) {
    return null;
  }

  if (errors.code) {
    return errors.code;
  }

  if (errors.errorCode) {
    return errors.errorCode;
  }

  if (errors[0]?.code) {
    return errors[0].code;
  }

  if (errors[0]?.errorCode) {
    return errors[0].errorCode;
  }

  return null;
};

export const getErrorMessageFromResponse = (response: any, defaultErrorMessage: string|null = null): string|null => {
  const errors = response.errors || response.error;

  if (!errors) {
    return defaultErrorMessage;
  }

  if (errors.message) {
    return errors.message.substring(0, 400);
  }

  if (errors[0]?.message) {
    return errors[0].message.substring(0, 400);
  }

  return defaultErrorMessage;
};

export const getErrorMessageFromTranslationByErrorCode = (errorCode: string): string|null => {
  if (
    errorCode
    && t.tc('errorCodes.' + errorCode)
    && t.tc('errorCodes.' + errorCode) !== 'errorCodes.' + errorCode
  ) {
    return t.tc('errorCodes.' + errorCode);
  }

  return null;
}
